<template>
    <ExportArabian v-if="horseBreed === 'ARABIAN'" :data="data" />
    <ExportThoroughbred v-if="horseBreed === 'THOROUGHBRED'" :data="data"/>
</template>

<script>
import {Previewer, registerHandlers} from "pagedjs";
import {getExportData} from "@/swagger/vue-api-client";
import ExportArabian from "./ExportArabian.vue";
import ExportThoroughbred from "./ExportThoroughbred.vue";
import CustomHandler from "./util/CustomHandlers";

export default {
    name: "ExportDocumentPrintView",
    components: {
        ExportArabian,
        ExportThoroughbred,
    },
    data() {
        return {
            horseBreed: this.$route.params.breed.toUpperCase(),
            horseId: this.$route.params.id,
            data: null,
            bodyClass: "export-document",
        };
    },
    mounted() {
        registerHandlers(CustomHandler);
        const app = document.getElementById("app");
        const noscript = document.getElementsByTagName("noscript")[0];
        if (app) app.classList.add(this.bodyClass);
        if (noscript) noscript.classList.add(this.bodyClass);
        this.getData();
    },
    methods: {
        getData() {
            getExportData({horseId: this.horseId})
                .then((response) => {
                    this.data = response.data;

                    const paged = new Previewer();
                    paged.preview();
                })
                .catch((error) => {
                    console.error("Error while downloading export data:", error);
                });
        },
    },
};
</script>

<style lang="scss">
@import "print-export-document-styles.scss";
</style>
